import { useTranslation } from 'react-i18next'

import { REQUEST_SINGLE_FIELD_API } from '../../../../constants/api'
import Button from '../../../Button'
import { FILTER_BAR_FILTER_TRIGGER_VARIANT, FilterBar } from '../../../Filter'
import { PageActions } from '../../../Page'
import {
  getRequestPermanentFilters,
  parseRequestPermanentFilters,
  REQUEST_VIEW_FILTERS,
  RequestAddButton,
} from '../../../Request'
import { getEntityTabFilterBarApiUrl } from '../../EntityTab.utils'
import { ENTITY_TAB_REQUESTS_FILTER_BAR_ITEMS_PROPS } from '../EntityTabRequests.constants'

import * as styles from './EntityTabRequestsToolbar.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function EntityTabRequestsToolbar({
  activeSubTab,
  availableFilters,
  entity,
  filterValues,
  hasVisibleFilters,
  isLoading,
  isWizardEnabled,
  ordering,
  pagination,
  qaName,
  scopeFilterKey,
  scopeId,
  shouldReloadFilters,
  shouldShowCreateButton,
  onAddAction,
  onChangeShouldReloadFilters,
  onReload,
  onSetFilterValues,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.toolbar}>
      {hasVisibleFilters || isLoading ? (
        <FilterBar
          responsive
          apiUrl={getEntityTabFilterBarApiUrl({
            baseApi: REQUEST_SINGLE_FIELD_API,
            scopeFilterKey,
            scopeId,
          })}
          availableFilters={availableFilters}
          className={styles.filterBar}
          entity={entity}
          excludeFilters={REQUEST_VIEW_FILTERS}
          filterBarItemsProps={ENTITY_TAB_REQUESTS_FILTER_BAR_ITEMS_PROPS}
          filterTriggerVariant={FILTER_BAR_FILTER_TRIGGER_VARIANT.COMPACT_ICON}
          filterValues={filterValues}
          getPermanentFilters={getRequestPermanentFilters}
          isSkeleton={isLoading}
          objectId={scopeId}
          ordering={ordering}
          pagination={{ per_page: pagination?.pageSize }}
          parsePermanentFilters={parseRequestPermanentFilters}
          setFilterValues={onSetFilterValues}
          shouldReloadValues={shouldReloadFilters}
          sub={activeSubTab}
          onChangeShouldReloadValues={onChangeShouldReloadFilters}
          onReload={onReload}
        />
      ) : null}
      <PageActions className={styles.actions} isLoading={isLoading}>
        {shouldShowCreateButton || isLoading ? (
          <RequestAddButton
            buttonProps={{
              Button: Button.Text,
              beforeIconProps: { Icon: PlusIcon },
              qaName: qaName.addNew,
              text: t('RequestTable.AddNewBtnKey'),
            }}
            isSkeleton={isLoading}
            isWizardEnabled={isWizardEnabled}
            selectProps={{
              controlProps: { buttonProps: { Button: Button.Text } },
            }}
            onAction={onAddAction}
          />
        ) : null}
      </PageActions>
    </div>
  )
}

export default EntityTabRequestsToolbar
